var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexelement"},[_c('div',[_vm._v(_vm._s(_vm.eventslot.name && _vm.eventslot.name.length > 1 ? _vm.eventslot.name : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }